import { LOCALE_KEY, LOCALE_PARAM, LOCALES, basePath, getLocale, publicHref } from "#lib/locale.ts";

export const autonym = (tag: string): string => {
  const name = new Intl.DisplayNames([tag], { type: "language" }).of(tag) ?? tag;
  return name.charAt(0).toLocaleUpperCase(tag) + name.slice(1);
};

export const localeOptions = (): { id: string; label: string }[] =>
  LOCALES.filter((tag) => tag !== "en-XA" || getLocale() === "en-XA").map((tag) => ({
    id: tag,
    label: autonym(tag),
  }));

export const pickLocale = (tag: string): void => {
  localStorage.setItem(LOCALE_KEY, tag);
  const url = new URL(globalThis.location.href);
  url.searchParams.delete(LOCALE_PARAM);
  url.pathname = publicHref(basePath(url.pathname), tag);
  globalThis.location.replace(url);
};
